export default __webpack_public_path__ + "static/media/charactor.0e400de9.webp";